import { Toast } from '@base-ui/react/toast';
import type { ReactNode } from 'react';
import { ToastList } from '@/components/ui/Toaster';

interface ToastProviderProps {
  children: ReactNode;
}

export const ToastProvider = ({ children }: ToastProviderProps) => (
  <Toast.Provider>
    {children}
    <Toast.Portal>
      <Toast.Viewport className="pointer-events-none fixed right-4 bottom-4 z-100 flex w-80 flex-col gap-2">
        <ToastList />
      </Toast.Viewport>
    </Toast.Portal>
  </Toast.Provider>
);
